import { Directive, ElementRef, EventEmitter, NgModule, OnInit, Output } from '@angular/core';

@Directive({
	standalone: false,
	selector: '[cbOnInit]',
})
export class CbOnInitDirective<T extends HTMLElement> implements OnInit {
	@Output('cbOnInit')
	public cbOnInit$$ = new EventEmitter<T>();

	public get nativeElement(): T {
		return this.elementRef.nativeElement;
	}

	constructor(private readonly elementRef: ElementRef<T>) {}

	ngOnInit(): void {
		this.cbOnInit$$.emit(this.nativeElement);
	}
}

@NgModule({
	declarations: [CbOnInitDirective],
	imports: [],
	exports: [CbOnInitDirective],
})
export class CbOnInitModule {}
